<template>
  <b-container class="col-md-10 mt-4"> 
    <div class="card p-3 shadow" style="border-radius:1em;">
      <h3 class="mb-3" style="text-align:left;" >Helpdesk Tickets 
        <!-- <span style="font-size:.7em;float:right;padding-right:10px;"><b-checkbox v-model="multiSelect"/> Enable Multi-Select </span> -->
      </h3>
      <ticket-table-list 
        :items="items" 
        maxHeight="500px"
        :enableMultiSelect="multiSelect"
        @click="onClick($event)" 
        @listClick="onClick( $event )"
      />
    </div>
  </b-container>
</template>

<script>
import TicketTableList from '@/components/TicketTableList.vue'

export default {
  name: 'tickettable',
  components: {
    TicketTableList
  },
  data () {
    return {
      multiSelect: false,
        items:[
                {
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "helpdesk",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },
                {
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "housekeeping",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "open",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "open",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "stuck",
                    "priority": "low",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "parked",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "complete",
                    "priority": "critical",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "helpdesk",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "helpdesk",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "complete",
                    "priority": "high",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "grounds",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "parked",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "stuck",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "open",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },{
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "workorder",
                    "ticketNumber": 30,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ?",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-10-20",
                    "_id": "5d66d961e13baf5b343356d9",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-02T04:20:09.361Z"
                },
                {
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "category": "Customer",
                    "raisedBy": "Courtney",
                    "isStar": true,
                    "isPin": false,
                    "ticketType": "helpdesk",
                    "ticketNumber": 31,
                    "tags": [],
                    "title": "This is my new ticket #31 - how does this show up or if this thing has a really long title that would go really far and wrap around if it's left untreated.",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "open",
                    "priority": "low",
                    "closed": false,
                    "dueDate": "2019-11-30",
                    "_id": "5d66d961e13baf5b343356d8",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-10-06T04:20:09.361Z"
                },
                {
                    "client": {
                    "clientName": "Courtney",
                    "clientEmail": "courtneylbrown1@outlook.com"
                    },
                    "assignedToPictureUrl": "https://devicenet.blob.core.windows.net/system/users/57d0a585aa0d65bc753f0547.JPG",
                    "assignedToEmail": "wolf@ioihan.com",
                    "assignedTo": "daWolf*",
                    "billable": false,
                    "isStar": false,
                    "isPin": false,
                    "ticketType": "helpdesk",
                    "ticketNumber": 32,
                    "category": "Helpdesk",
                    "raisedBy": "Courtney",
                    "tags": [],
                    "title": "Wonder how to add ticket categories ? ",
                    "description": "I'm sure this isn't implemented/written code yet but would be cool to have a TESTING category to add improvements and I find while testing this. :)\n\nI would love to add a testing category -- just need to have some additional information on how to implement this.\n\nchange this to get an email\n\n\n\n\n",
                    "active": true,
                    "status": "new",
                    "priority": "normal",
                    "closed": false,
                    "dueDate": "2019-09-20",
                    "_id": "5d66d961e13baf5b343356d7",
                    "lastUpdateBy": "Wolfgang",
                    "createdAt": "2019-08-28T19:43:29.753Z",
                    "updatedAt": "2019-09-30T04:20:09.361Z"
                }
          ]
    }
  },
  methods: {
    onClick( ticketId ) {
      alert( "You clicked ticket id [" + ticketId.toString() + "]" );
    }
  }
}
</script>